import axios from "axios";
import "./axiosInterceptor";

export const PASARELA = process.env.VUE_APP_URLPASARELA;

export const Devolucion = {
  devolver(payload) {
    return axios.post(PASARELA + "/administracion/devolucion", payload);
  },
};
